<template>
	<div>
		<Breadcrumb>
			<Breadcrumb-item href="wareHouseManage.html">基础管理</Breadcrumb-item>
			<Breadcrumb-item>店铺管理</Breadcrumb-item>
		</Breadcrumb>
		<Form :label-width="120" inline :model="queryForm" class="wms-search-wapper wms-mt20">
			<Form-item label="店铺编号：">
				<Input size="small" v-model="queryForm.shopCode" placeholder=""></Input>
			</Form-item>
			<Form-item label="店铺名称：">
				<Input size="small" v-model="queryForm.shopName" placeholder=""></Input>
			</Form-item>
			<Form-item :label-width="10" style="width: auto">
				<Button size="small" class="wms-mr10 wms-btn-ghost" type="ghost" @click="queryList">查询</Button>
				<Button size="small" class="wms-mr10 wms-btn-ghost" type="ghost" @click="clear">清空</Button>
			</Form-item>
		</Form>
		<IconBtnGroup :dataSource="btnGroup" @on-click="btnClickHandle" class="wms-mt10"></IconBtnGroup>
		<div class="wms-mt20">
			<AgGridVueCustom style="width: 100%;" class="ag-fresh wms-table"
							 :gridOptions="gridOptions"
							 :columnDefs="columnDefs"
							 :rowData="rowData"
							 :enableColResize="true"
							 rowSelection="multiple"
							 :suppressRowClickSelection="true"
							 :groupUseEntireRow="true"
							 :rowHeight="tableHeaderRowHeight"
							 :headerHeight="tableRowHeight"
							 :selectionChanged="selectChange"
							 domLayout="autoHeight"
							 suppressNoRowsOverlay
							 :overlayLoadingTemplate="loadingTemplate"
							 :suppressMovableColumns="false"
							 :enableServerSideSorting="true"
							 :sortChanged="sortChanged"
			>
			</AgGridVueCustom>
		</div>
		<div class="wms-page-wapper">
			<span class="setsize ">第{{(curPage-1)*DefaultPageSize+1}}-{{ total-curPage*DefaultPageSize<0 ? total:curPage*DefaultPageSize }}条记录,   总共{{total}}条记录</span>
			<Page :total="total" :page-size="DefaultPageSize" :page-size-opts="DefaultPageSizeOpt"
				  @on-page-size-change="pageSizeChange"
				  @on-change="updateCurPage" :current="curPage" show-elevator show-sizer
				  class="wms-page float-right wms-mr5"></Page>
		</div>
		<Modal v-model="bulkOperationPop"
			   title="注意"
			   width="400"
			   :mask-closable="true">
			<p slot="header" style="color:#ff9900; text-align:center">
				<Icon type="information-circled"></Icon>
				<span>操作结果</span>
			</p>
			<div style="max-height: 100px; overflow:auto">
				<p v-for="item in blukData" :key="item">{{item}}</p>
			</div>
			<div slot="footer">
				<Button type="ghost" @click="bulkOperationPop=false">知道了！</Button>
			</div>
		</Modal>
	</div>
</template>
<script>
    import {InterObj} from 'utils/serviceConst'
    import IconBtnGroup from 'components/common/iconBtnGroup/iconBtnGroup.vue'
    import {loadingTemplate} from 'utils/template'
    import {TableHeaderRowHeight, TableRowHeight, DefaultPageSize, DefaultPageSizeOpt} from 'utils/const'
    import CellOperate from 'components/common/agTableComponent/cellOperate.vue'

    import provinceCity from 'utils/provinceCity'
    import DetailItem from 'components/common/detailItem/detailItem.vue'

    export default {
        name: 'shop',
        data() {
            return {
                bulkOperationPop: false,
                blukData: [],				// 错误信息
                queryForm: {
                    shopCode: '',
                    shopName: ''
                },
                btnGroup: [
                    {
                        text: '新增',
                        icon: 'icon-Newly_added',
                        click: () => this.$router.push({name: 'shop-add'})
                    },
                    {
                        text: '删除',
                        icon: 'icon-delete',
                        click: () => this.operate('del')
                    },
                    {
                        text: '启用',
                        icon: 'icon-enable',
                        click: () => this.operate('open')
                    },
                    {
                        text: '停用',
                        icon: 'icon-disable',
                        click: () => this.operate('stop')
                    }
                ],
                gridOptions: {},
                columnDefs: [
                    {
                        headerName: '',
                        field: 'selection',
                        pinned: 'left',
                        checkboxSelection: true,
                        headerCheckboxSelection: true,
                        width: 60,
                        maxWidth: 60,
                        minWidth: 60,
                        suppressSorting: true
                    },
                    {
                        headerName: '序号',
                        field: 'storeHouseIndex',
                        minWidth: 60,
                        width: 60,
                        pinned: 'left',
                        cellRenderer: function(params) {
                            let index = Number(params.rowIndex) + 1
                            return '<span>' + index + '</span>'
                        }
                    },
                    {
                        headerName: '操作',
                        field: 'operate',
                        pinned: 'left',
                        maxWidth: 100,
                        minWidth: 100,
                        cellOperate: [
                            {
                                name: '查看',
                                click: (params) => {
                                    this.$router.push({
                                        name: 'shop-detail',
                                        query: {
                                            id: params.data.shopId
                                        }
                                    })
                                }
                            },
                            {
                                name: '修改',
                                click: (params) => {
                                    this.$router.push({
                                        name: 'shop-edit',
                                        query: {
                                            id: params.data.shopId
                                        }
                                    })
                                }
                            }
                        ],
                        cellRendererFramework: CellOperate,
                        suppressSorting: true
                    },
                    {
                        headerName: '店铺编号',
                        field: 'shopCode',
                        minWidth: 180
                    },
                    {
                        headerName: '店铺名称',
                        field: 'shopName',
                        minWidth: 180
                    },
                    {
                        headerName: '货主',
                        field: 'ownerName',
                        minWidth: 100
                    },
                    {
                        headerName: '联系人',
                        field: 'name',
                        minWidth: 100
                    },
                    {
                        headerName: '手机号码',
                        field: 'mobile',
                        minWidth: 150
                    },
                    {
                        headerName: '联系电话',
                        field: 'phone',
                        minWidth: 150
                    },
                    {
                        headerName: '地址',
                        field: 'address',
                        minWidth: 300,
                        cellRenderer: function(param) {
                            return `${param.data.region}-${param.data.address}`
                        }
                    },
                    {
                        headerName: '备注',
                        field: 'remark',
                        minWidth: 150
                    },
                    {
                        headerName: '状态',
                        field: 'status',
                        minWidth: 100,
                        cellRenderer: function(param) {
                            return param.data.status === '1' ? '启用' : '停用'
                        }
                    }
                ],
                rowData: [],
                loadingTemplate,
                tableHeaderRowHeight: TableHeaderRowHeight,
                tableRowHeight: TableRowHeight,
                DefaultPageSize: DefaultPageSize,
                DefaultPageSizeOpt: DefaultPageSizeOpt,
                curPage: 1,
                total: 0,
                provinceData: provinceCity,
                selectList: [],
                orderByClause: '',
                selectArr: [],
                selectCodes: [],
                selectIds: []
            }
        },
        activated() {
            this.queryList()
            reSetAgTable(this.gridOptions, this.columnDefs, this.orderByClause)
        },
        methods: {
            async queryList(page) {
                this.$Loading.start()
                this.curPage = Number(page) ? page : 1
                let params = {
                    page: this.curPage,
                    pageSize: this.DefaultPageSize,
                    shopCode: this.queryForm.shopCode,
                    shopName: this.queryForm.shopName,
                    orderByClause: this.orderByClause,
                    useLike: true
                }
                let res = await requestMethods.get(InterObj.shopList, params)
                if (res.result === 'success') {
                    this.rowData = res.data
                    this.total = parseInt(res.count)
                    this.$Loading.finish()
                    this.gridOptions.api.deselectAll()
                } else {
                    this.$Loading.error()
                    this.$Notice.warning({desc: res.msg})
                }
            },
            // 排序
            sortChanged() {
                let sortModal = this.gridOptions.api.getSortModel()
                this.orderByClause = (sortModal[0] ? sortModal[0].colId + ':' + sortModal[0].sort : '')
                this.queryList()
            },
            pageSizeChange(val) {
                this.DefaultPageSize = val
                this.queryList()
            },
            updateCurPage(val) {
                this.queryList(val)
            },
            clear() {
                this.queryForm = {
                    code: '',
                    name: ''
                }
            },
            btnClickHandle(params) {
                params.click()
            },
            selectChange() {
                let selectArr = this.gridOptions.api.getSelectedRows()
                this.selectCodes = _.map(selectArr, 'code')
                this.selectIds = _.map(selectArr, 'shopId')
            },
            operate(sign) {
                if (!this.selectCodes.length) {
                    this.$Notice.warning({desc: '请选择数据！'})
                    return
                }
                let params = {ids: this.selectIds.join(',')}
                let url
                switch (sign) {
                    case 'del':
                        url = InterObj.deleteShop
                        break
                    case 'open':
                        url = InterObj.updateShopStatus
                        params = Object.assign({}, params, {status: '1'})
                        break
                    case 'stop':
                        url = InterObj.updateShopStatus
                        params = Object.assign({}, params, {status: '0'})
                        break
                    default:
                        break
                }
                requestMethods.post(url, params).then(res => {
                    this.queryList()
                    if (res.data.length) {
                        this.bulkOperationPop = true
                        this.blukData = res.data || []
                    } else {
                        this.$Message.success('操作成功')
                    }
                })
            }
        },
        components: {
            IconBtnGroup,
            DetailItem
        }
    }
</script>
<style lang="less">
	.basicContainer {
		.btn-wrapper {
			text-align: center
		}
		.ivu-form-item-validating .ivu-input-icon + .ivu-input {
			padding-right: 7px;
		}
	}
</style>
